var map = {
	"./+379.png": 2140,
	"./+383.png": 2141,
	"./+599.png": 2142,
	"./+672.png": 2143,
	"./1.png": 2144,
	"./10.png": 2145,
	"./100.png": 2146,
	"./101.png": 2147,
	"./102.png": 2148,
	"./103.png": 2149,
	"./104.png": 2150,
	"./105.png": 2151,
	"./106.png": 2152,
	"./107.png": 2153,
	"./108.png": 2154,
	"./109.png": 2155,
	"./11.png": 2156,
	"./110.png": 2157,
	"./111.png": 2158,
	"./112.png": 2159,
	"./113.png": 2160,
	"./114.png": 2161,
	"./115.png": 2162,
	"./116.png": 2163,
	"./117.png": 2164,
	"./118.png": 2165,
	"./119.png": 2166,
	"./12.png": 2167,
	"./120.png": 2168,
	"./121.png": 2169,
	"./122.png": 2170,
	"./123.png": 2171,
	"./124.png": 2172,
	"./125.png": 2173,
	"./126.png": 2174,
	"./127.png": 2175,
	"./128.png": 2176,
	"./129.png": 2177,
	"./13.png": 2178,
	"./130.png": 2179,
	"./131.png": 2180,
	"./132.png": 2181,
	"./133.png": 2182,
	"./134.png": 2183,
	"./135.png": 2184,
	"./136.png": 2185,
	"./137.png": 2186,
	"./138.png": 2187,
	"./139.png": 2188,
	"./14.png": 2189,
	"./140.png": 2190,
	"./141.png": 2191,
	"./142.png": 2192,
	"./143.png": 2193,
	"./144.png": 2194,
	"./145.png": 2195,
	"./146.png": 2196,
	"./147.png": 2197,
	"./148.png": 2198,
	"./149.png": 2199,
	"./15.png": 2200,
	"./150.png": 2201,
	"./151.png": 2202,
	"./152.png": 2203,
	"./153.png": 2204,
	"./154.png": 2205,
	"./155.png": 2206,
	"./156.png": 2207,
	"./157.png": 2208,
	"./158.png": 2209,
	"./159.png": 2210,
	"./16.png": 2211,
	"./160.png": 2212,
	"./161.png": 2213,
	"./162.png": 2214,
	"./163.png": 2215,
	"./164.png": 2216,
	"./165.png": 2217,
	"./166.png": 2218,
	"./167.png": 2219,
	"./168.png": 2220,
	"./169.png": 2221,
	"./17.png": 2222,
	"./170.png": 2223,
	"./171.png": 2224,
	"./172.png": 2225,
	"./173.png": 2226,
	"./174.png": 2227,
	"./175.png": 2228,
	"./176.png": 2229,
	"./177.png": 2230,
	"./178.png": 2231,
	"./179.png": 2232,
	"./18.png": 2233,
	"./180.png": 2234,
	"./181.png": 2235,
	"./182.png": 2236,
	"./183.png": 2237,
	"./184.png": 2238,
	"./185.png": 2239,
	"./186.png": 2240,
	"./187.png": 2241,
	"./188.png": 2242,
	"./189.png": 2243,
	"./19.png": 2244,
	"./190.png": 2245,
	"./191.png": 2246,
	"./192.png": 2247,
	"./193.png": 2248,
	"./194.png": 2249,
	"./195.png": 2250,
	"./196.png": 2251,
	"./197.png": 2252,
	"./198.png": 2253,
	"./199.png": 2254,
	"./2.png": 2255,
	"./20.png": 2256,
	"./200.png": 2257,
	"./202.png": 2258,
	"./203.png": 2259,
	"./204.png": 2260,
	"./205.png": 2261,
	"./206.png": 2262,
	"./207.png": 2263,
	"./208.png": 2264,
	"./209.png": 2265,
	"./21.png": 2266,
	"./210.png": 2267,
	"./211.png": 2268,
	"./212.png": 2269,
	"./213.png": 2270,
	"./214.png": 2271,
	"./215.png": 2272,
	"./216.png": 2273,
	"./217.png": 2274,
	"./218.png": 2275,
	"./219.png": 2276,
	"./22.png": 2277,
	"./220.png": 2278,
	"./221.png": 2279,
	"./223.png": 2280,
	"./224.png": 2281,
	"./225.png": 2282,
	"./226.png": 2283,
	"./227.png": 2284,
	"./228.png": 2285,
	"./229.png": 2286,
	"./23.png": 2287,
	"./230.png": 2288,
	"./231.png": 2289,
	"./232.png": 2290,
	"./233.png": 2291,
	"./234.png": 2292,
	"./235.png": 2293,
	"./237.png": 2294,
	"./238.png": 2295,
	"./239.png": 2296,
	"./24.png": 2297,
	"./240.png": 2298,
	"./241.png": 2299,
	"./242.png": 2300,
	"./244.png": 2301,
	"./245.png": 2302,
	"./247.png": 2303,
	"./248.png": 2304,
	"./249.png": 2305,
	"./25.png": 2306,
	"./26.png": 2307,
	"./27.png": 2308,
	"./29.png": 2309,
	"./3.png": 2310,
	"./30.png": 2311,
	"./32.png": 2312,
	"./33.png": 2313,
	"./34.png": 2314,
	"./35.png": 2315,
	"./36.png": 2316,
	"./37.png": 2317,
	"./38.png": 2318,
	"./39.png": 2319,
	"./4.png": 2320,
	"./40.png": 2321,
	"./41.png": 2322,
	"./42.png": 2323,
	"./43.png": 2324,
	"./44.png": 2325,
	"./45.png": 2326,
	"./46.png": 2327,
	"./47.png": 2328,
	"./48.png": 2329,
	"./49.png": 2330,
	"./5.png": 2331,
	"./50.png": 2332,
	"./51.png": 2333,
	"./52.png": 2334,
	"./53.png": 2335,
	"./54.png": 2336,
	"./55.png": 2337,
	"./56.png": 2338,
	"./57.png": 2339,
	"./58.png": 2340,
	"./59.png": 2341,
	"./6.png": 2342,
	"./60.png": 2343,
	"./61.png": 2344,
	"./62.png": 2345,
	"./63.png": 2346,
	"./64.png": 2347,
	"./65.png": 2348,
	"./66.png": 2349,
	"./67.png": 2350,
	"./68.png": 2351,
	"./69.png": 2352,
	"./7.png": 2353,
	"./70.png": 2354,
	"./71.png": 2355,
	"./72.png": 2356,
	"./73.png": 2357,
	"./74.png": 2358,
	"./75.png": 2359,
	"./76.png": 2360,
	"./77.png": 2361,
	"./78.png": 2362,
	"./8.png": 2363,
	"./80.png": 2364,
	"./81.png": 2365,
	"./82.png": 2366,
	"./83.png": 2367,
	"./84.png": 2368,
	"./85.png": 2369,
	"./86.png": 2370,
	"./87.png": 2371,
	"./88.png": 2372,
	"./89.png": 2373,
	"./90.png": 2374,
	"./91.png": 2375,
	"./92.png": 2376,
	"./93.png": 2377,
	"./94.png": 2378,
	"./95.png": 2379,
	"./96.png": 2380,
	"./99.png": 2381,
	"./East Timor.png": 2382,
	"./Rapa Nui.png": 2383,
	"./abkhazia.png": 2384,
	"./azores islands.png": 2385,
	"./balearic islands.png": 2386,
	"./basque country.png": 2387,
	"./bonaire.png": 2388,
	"./british columbia.png": 2389,
	"./canary islands.png": 2390,
	"./ceuta.png": 2391,
	"./corsica.png": 2392,
	"./england.png": 2393,
	"./european union.png": 2394,
	"./galapagos islands.png": 2395,
	"./hawaii.png": 2396,
	"./madeira.png": 2397,
	"./melilla.png": 2398,
	"./nato.png": 2399,
	"./northern cyprus.png": 2400,
	"./orkney islands.png": 2401,
	"./ossetia.png": 2402,
	"./pitcairn islands.png": 2403,
	"./saba island.png": 2404,
	"./sahrawi arab democratic republic.png": 2405,
	"./sardinia.png": 2406,
	"./scotland.png": 2407,
	"./somaliland.png": 2408,
	"./st barts.png": 2409,
	"./swaziland.png": 2410,
	"./tibet.png": 2411,
	"./transnistria.png": 2412,
	"./united nations.png": 2413,
	"./wales.png": 2414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2139;